// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyView_wrapper__s6u5h","content":"EmptyView_content__rVpor","icon":"EmptyView_icon___EFTM","button":"EmptyView_button__i4a_U"};